class StackNavHandler {
  constructor() {
    this.registerMenuCollapse();
    this.registerMenuNavigation();
  }

  isMobile() {
    let mq = window.matchMedia("(min-width: 992px)");
    return !mq.matches
  }

  registerMenuCollapse() {
    let body = document.getElementsByTagName('body')[0];
    let menuContainer = document.getElementById('main-menu-container');

    menuContainer.addEventListener('shown.bs.collapse', function (event) {
      body.classList.add("menu-open");
    })
    menuContainer.addEventListener('hidden.bs.collapse', function (event) {
      body.classList.remove('menu-open')
    })
  }

  showNavItem(event) {
    if (this.isMobile()) {
      event.preventDefault()
      let link = event.currentTarget;
      let container = link.parentElement;
      container.classList.add('stack-nav-item-active');
    }
  }

  hideNavItem(event) {
    if (this.isMobile()) {
      event.preventDefault()
      let link = event.currentTarget;
      let container = link.parentElement.parentElement;
      container.classList.remove('stack-nav-item-active');
    }
  }

  registerMenuNavigation() {
    let instance = this;
    let menuItems = document.querySelectorAll('.stack-nav ul > li.menu-item-has-children > a');
    Array.from(menuItems).forEach(function (item) {
      item.addEventListener('click', function (event) {
        instance.showNavItem(event);
      });
    });

    let backLinks = document.querySelectorAll('.stack-nav ul > li.menu-item-has-children .back-link');
    Array.from(backLinks).forEach(function (item) {
      item.addEventListener('click', function (event) {
        instance.hideNavItem(event);
      });
    });

  }
}
export default StackNavHandler;
